export default function Reassurances() {
  const items = [
    { icon: "ri-time-line", label: "Intervention 24h" },
    { icon: "ri-file-list-3-line", label: "Devis gratuit" },
    { icon: "ri-shield-check-line", label: "Toutes marques" },
    { icon: "ri-shield-check-line", label: "Garantie 10 ans" },
  ];

  return (
    <section className="bg-white py-6 md:py-8 border-b border-[#E2E8F0]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {items.map((item) => (
            <div key={item.label} className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#00B3A4]/10">
                <i className={`${item.icon} text-[#00B3A4] text-lg`}></i>
              </div>
              <span className="text-[#143A66] text-sm font-semibold">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}